<ng-container *ngIf="productType; else typeNotSet">
  <span class="badge {{ size }}" [ngClass]="'badge-' + productType.code">{{ productType.name }}</span>
</ng-container>
<ng-template #typeNotSet>
  <span class="badge {{ size }} badge-NS">Type Not Set</span>
</ng-template>
